import { FC } from 'react';
import useWarnings from '@hooks/useWarnings';
import { Alert, AlertTitle, Box } from '@mui/material';
import useLocales from '~/hooks/useLocales';
import { ALL_WARNINGS } from './constants';
import { WarningsState } from '~/@types/warnings_state';
import { styles } from './styles';

const Warnings: FC = () => {
  const { t } = useLocales();
  const { warningsState, changeWarningsState } = useWarnings();

  return (
    <Box sx={styles.container}>
      {Object.entries(warningsState).map(([type, state]) => (
        <div key={type}>
          {state && (
            <Alert
              severity="warning"
              sx={styles.alert}
              onClose={() => changeWarningsState(type, false)}
            >
              <AlertTitle>{t(ALL_WARNINGS[type as keyof WarningsState].title)}</AlertTitle>
              {t(ALL_WARNINGS[type as keyof WarningsState].description)}
            </Alert>
          )}
        </div>
      ))}
    </Box>
  );
};

export default Warnings;
